import { type HttpClientConfig } from 'core/infra/http/HttpClient'
import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import sentry from 'legacy/utils/sentry'

import { RateCommandCenterRepository } from '../infra/RateCommandCenterRepository'

export type RefreshTokenFactoryDependencies = {
  rateCommandCenterRepository: RateCommandCenterRepository
}

export function refreshTokenFactory({
  rateCommandCenterRepository,
}: RefreshTokenFactoryDependencies) {
  return async function refreshToken({
    token,
    data,
    config,
  }: {
    token: string
    data?: { rate_uuid?: string; bulk_invite_uuid?: string }
    config?: Partial<HttpClientConfig>
  }) {
    try {
      return await rateCommandCenterRepository.refreshToken(token, data, config)
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not refresh the token', { cause: error as Error })
    }
  }
}

export function refreshToken({
  token,
  data,
  config,
}: {
  token: string
  data?: { rate_uuid?: string; bulk_invite_uuid?: string; tender_uuid?: string }
  config?: Partial<HttpClientConfig>
}) {
  const httpClient = new ShipperGuideClient()
  const rateCommandCenterRepository = new RateCommandCenterRepository({ httpClient })
  const submit = refreshTokenFactory({ rateCommandCenterRepository })
  return submit({ token, data, config })
}
